import { Box } from '@mui/material'
import Input from '../../../components/Input/Input'

const QuestionInput = ({ control }: { control: any }) => {
  return (
    <Box padding={1} marginBottom={3}>
      <Input
        name="pollQuestion.question"
        control={control}
        label="Question"
        required
        fullWidth
        removeMarginTop
        placeholder="Enter a question to ask attendees..."
      />
    </Box>
  )
}
export default QuestionInput
